import React from 'react';
import usePageTitle from 'commons/page_title';

export default function QABasicRules()
{
    usePageTitle('Q&A Basic Rules');
    return (
        <div>
            <h1>Q&amp;A Basic Rules</h1>
            <h2>How questions, answers and comments work</h2>
            <p>
                The Q&amp;A is an interactive section for asking and answering questions about CCH Tagetik’s product and solutions.
                If you have a doubt on the best way to use CCH Tagetik, or if you don’t know how to resolve a need that you have,
                you can use this tool to ask your &nbsp;question to the whole CCH Tagetik Community.
                We also encourage all members of this community to be active and answer the questions to share your knowledge,
                ideas, experiences and product expertise. &nbsp;</p> <p>The Q&amp;A section is designed for asking and answering questions,
                not for open-ended discussions. Despite that, each question and answer can be commented on. You can give one answer to each
                question and you will have the possibility to edit your own answer.
            </p>
            <p>The official language is English.</p>
            <p><strong><em>Important!!!</em></strong> The Q&amp;A section is not a Support tool, in case you need to fix an issue with CCH Tagetik,
                you should submit a new ticket using <a href="https://cchtagetik.force.com/CustomerPortal/s/login/?ec=302&startURL=%2FCustomerPortal%2Fs%2F" target="_blank" rel="noreferrer">Support Portal</a>.
            </p>

            <h2>Please search before asking your questions</h2>
            <p>Type your question in the search bar and see whether a similar question has been asked before.</p>
            <p>In addition, it is possible to click on tags to fire a query.</p>

            <h2>Closed questions and correct answers</h2>
            <p>
                Q&amp;A admins will periodically approve the correct answers, which will be recognizable from the green ribbon.
                The answers can also be closed for the following reasons:
            </p>
            <ul>
                <li>duplicate question</li>
                <li>question is off-topic or not relevant</li>
                <li>too subjective and argumentative</li>
                <li>not a real question</li>
                <li>question is not relevant or outdated</li>
                <li>question contains offensive or malicious remarks</li>
                <li>spam or advertising</li>
                <li>too localized</li>
            </ul>
            <p>
                Q&amp;A admins and moderators can also choose the <strong>right answer</strong>. In case a question has been closed because has been resolved,
                the right answer is highlighted in green.
            </p>
            <p>
                You will not have the possibility to add answers to closed questions however each closed question
                and answer can be commented on. Q&amp;A admin and moderators can re-open a question should they feel it is necessary.
            </p>
            <h2>Voting</h2>
            <p>
                Voting in CCH Tagetik Q&amp;A helps to select best answers and thank most helpful users. &nbsp;Please vote when you find helpful information,
                it really helps the CCH Tagetik Q&amp;A community.
            </p>
            <p>
                In case you need <strong>support with the Q&amp;A tool</strong>, please contact <a href="mailto:tgk-dl-community@wolterskluwer.com">tgk-dl-community@wolterskluwer.com</a>
            </p>
        </div>
    );
};
